import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { push } from 'redux-first-history';
import { parseUrl } from 'query-string';

import { Logger } from '@/services/errors/appLogger';
import * as API from '../services/ApiCategories/users';
import * as Actions from '../store/users/actions';
import * as Types from '../store/users/types';
import { HomePaths } from '../services/dictionaries/Paths';

const { ActionTypes } = Types;

function* activateUser(action: Types.ActivateUsersAction): any {
    const { payload, meta } = action;
    yield put(Actions.ActivateUserStart());
    try {
        const user = yield call(API.activateUser, payload);
        yield put(Actions.ActivateUserSuccess(meta));
        const url = parseUrl(user.data, { decode: false });
        yield put(push(`${HomePaths.Login}?userName=${url?.query?.user}`));
    } catch (e) {
        const error = e?.response?.data?.Error ? e?.response?.data?.Error : e.message;
        Logger.error(error);
        yield put(Actions.ActivateUserError(e.response.data, meta));
    }
}

function* checkIfUserIsActivated(action: Types.CheckIfUserIsActivatedAction): any {
    const { payload } = action;
    yield put(Actions.CheckIfUserIsActivatedStart(payload.username, payload.verificationCode));
    try {
        const isUserActive = yield call(API.checkIfUserIsActivated, payload.username, payload.verificationCode);
        yield put(Actions.CheckIfUserIsActivatedSuccess(isUserActive.data));

        if (isUserActive.data.Activated === true) {
            yield put(push('alreadyregistered'));
        }
    } catch (e) {
        yield put(Actions.CheckIfUserIsActivatedError(e.response.data?.Error ?? e.message));
    }
}

function* activateUserWatcher(): any {
    yield takeEvery(ActionTypes.ACTIVATE_USER, activateUser);
}

function* checkIfUserIsActivatedWatcher(): any {
    yield takeEvery(ActionTypes.CHECK_USER_REGISTRATION, checkIfUserIsActivated);
}

const usersSagas = [fork(activateUserWatcher), fork(checkIfUserIsActivatedWatcher)];

export default usersSagas;
